export default "/_next/static/chunks/fonts/Channel4Chadwick-Regular-9e12e8efbe764ab414a16809ad2b225c.woff";